import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SignIn from "./index";
import { signInUser } from "../../modules/user/actions";

class SignInContainer extends React.Component {
  componentDidMount() {
    // if (this.props.user && this.props.user.role === "admin") {
    //   this.props.history.push("/admin/blog");
    // } else if (this.props.user && this.props.user.role === "ta") {
    //   this.props.history.push("/tatest/survey");
    // }
  }

  render() {
    return <SignIn {...this.props} type="admin" />;
  }
}

function mapStateToProps(state) {
  return {
    submitting: state.user.submitting,
    user: state.user.user,
    errorMessage: state.user.error,
    signInType: state.user.signInType,
    language: state.preference.language
  };
}

const mapActionsToProps = {
  signInUser
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(SignInContainer)
);



// WEBPACK FOOTER //
// ./src/pages/SignIn/container.js